import { Controller } from "stimulus";
import disableElement from "../../functions/disableElement";
import enableElement from "../../functions/enableElement";

export default class extends Controller {
  static get targets() {
    return ["checkbox"];
  }

  connect() {
    if (this.preventOnLoad) {
      this.updateState();
    }
  }

  updateState() {
    this.inputs.forEach(input => {
      this.mode(input);
    });
  }

  get mode() {
    if (this.checkboxTarget.checked) {
      return enableElement;
    } else {
      return disableElement;
    }
  }

  get preventOnLoad() {
    return this.element.dataset.preventOnLoad === "true";
  }

  get inputs() {
    return [
      ...this.element.querySelectorAll("input"),
      ...this.element.querySelectorAll("select"),
      ...this.element.querySelectorAll("textarea")
    ].filter(input => {
      return input !== this.checkboxTarget;
    });
  }
}
